export default "__VITE_ASSET__B6LGXhl1__"